var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55968_13129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55968_13129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "refresh",
    d: "M9.99998 16.6666C8.13887 16.6666 6.56248 16.0208 5.27081 14.7291C3.97915 13.4374 3.33331 11.861 3.33331 9.99992C3.33331 8.13881 3.97915 6.56242 5.27081 5.27075C6.56248 3.97909 8.13887 3.33325 9.99998 3.33325C10.9583 3.33325 11.875 3.53117 12.75 3.927C13.625 4.32284 14.375 4.88881 15 5.62492V3.33325H16.6666V9.16658H10.8333V7.49992H14.3333C13.8889 6.72214 13.2812 6.11103 12.5104 5.66659C11.7396 5.22214 10.9028 4.99992 9.99998 4.99992C8.61109 4.99992 7.43054 5.48603 6.45831 6.45825C5.48609 7.43047 4.99998 8.61103 4.99998 9.99992C4.99998 11.3888 5.48609 12.5694 6.45831 13.5416C7.43054 14.5138 8.61109 14.9999 9.99998 14.9999C11.0694 14.9999 12.0347 14.6944 12.8958 14.0833C13.7569 13.4721 14.3611 12.6666 14.7083 11.6666H16.4583C16.0694 13.1388 15.2778 14.3402 14.0833 15.2708C12.8889 16.2013 11.5278 16.6666 9.99998 16.6666Z",
    fill: "#5F5C71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.0b3b7394f76fb409932d0c912aa88649.svg";
export { ForwardRef as ReactComponent };